<template>
  <lb-dialog v-model="internalValue" heading="Warning" :width="width" data-testid="warning-dialog">
    <template v-slot:body>
      <div class="pa-6" data-testid="warning-dialog__body">
        <div class="d-flex align-center mb-4" data-testid="warning-dialog__header">
          <v-icon :color="iconColor" large class="mr-3" data-testid="warning-dialog__icon">{{ icon }}</v-icon>
          <span class="text-h6 font-weight-medium" data-testid="warning-dialog__title">{{ title }}</span>
        </div>
        <v-divider class="mb-4"></v-divider>
        <div class="warning-message-box" data-testid="warning-dialog__message">
          {{ message }}
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn 
        @click="handleClose" 
        :color="buttonColor" 
        elevation="2"
        class="px-6"
        rounded
        data-testid="warning-dialog__close-button"
      >
        <v-icon left small data-testid="warning-dialog__button-icon">{{ buttonIcon }}</v-icon>
        <span>{{ buttonText }}</span>
      </v-btn>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'LbWarningDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Important Notice'
    },
    icon: {
      type: String,
      default: 'mdi-alert-circle'
    },
    iconColor: {
      type: String,
      default: 'warning'
    },
    buttonText: {
      type: String,
      default: 'Close'
    },
    buttonIcon: {
      type: String,
      default: 'mdi-check'
    },
    buttonColor: {
      type: String,
      default: 'primary'
    },
    width: {
      type: [String, Number],
      default: 600
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped>
.warning-message-box {
  background-color: rgba(255, 152, 0, 0.1);
  border-left: 4px solid #FF9800;
  border-radius: 4px;
  padding: 16px;
  color: #FF9800;
  font-size: 1rem;
}
</style>